import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { authApi } from '../api/endpoints/auth'
import { useAppDispatch } from './store'

/** After tokens: read /me and go to hero creation or the game. */
export function useEnter() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  return useCallback(async (to = '/play') => {
    const req = dispatch(authApi.endpoints.me.initiate(undefined, { forceRefetch: true }))
    try {
      const me = await req.unwrap()
      navigate(me.has_hero ? to : '/hero/new', { replace: true })
    } finally {
      req.unsubscribe()
    }
  }, [dispatch, navigate])
}
